import { ReactNode } from 'react';
import { CircularProgress } from '@mui/material';
import { LoaderWrapper } from '@styles/StyledDiv';
import { Flex } from '@styles/ContactManager/TabsStyles';

interface IContactManagerLayout {
  children?: JSX.Element | ReactNode;
  isLoading?: boolean;
}

export const ContactManagerLayout = ({ children, isLoading = false }: IContactManagerLayout) => {
  return (
    <Flex>
      {isLoading ? (
        <LoaderWrapper>
          <CircularProgress />
        </LoaderWrapper>
      ) : (
        <div style={{ width: '100%' }}>{children}</div>
      )}
    </Flex>
  );
};
